/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;

    export class PackagesSection  extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        public filter: any;
        public showFilteredItems: boolean = false;
        public isPreviewMassUpdate: boolean = false;
        public filterCriteria: any = {
            priceGroupId: '',
        };
        public amount: any;
        public massUpdateCriteria: any = {
            increase: false,
            amount: 0,
            isPercent: false,
            isMembershipOnly: null,
        };
        public revertLocation: boolean = false;

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {

            this.postCancel();
            this.takeBackup();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            this.isPreviewMassUpdate = false;

            this.filter = {
                sort: [
                    {
                        id: true,
                        displayName: "LABEL_INCREASE"
                    },
                    {
                        id: false,
                        displayName: "LABEL_DECREASE"
                    },
                ],
                membershipOnly: [
                    {
                        id: null,
                        displayName: "LABEL_ALL_PACKAGES"
                    },
                    {
                        id: true,
                        displayName: "LABEL_MEMBERSHIP_USE_ONLY"
                    },
                    {
                        id: false,
                        displayName: "LABEL_NON_MEMBERSHIP_USE"
                    },
                ]
            };

            this.postCancel();
        }

        public prevUnselected(): void {
            this.sectionEndpoint = '';

            super.prevUnselected();
        }

        public defaultCriteria() {
            return this.filterCriteria;
        }

        public postCancel(): void {
            this.isPreviewMassUpdate = false;

            this.filterCriteria.priceGroupId = this.parentItemId;
            this.filterCriteria.amount = 0;

            // set select element to default value from ng-selected
            this.massUpdateCriteria.increase = 'unexisting value';
            this.filterCriteria.isMembershipOnly = 'unexisting value';

            this.amount = 0;
            this.massUpdateCriteria.amount = 0;
            this.massUpdateCriteria.isPercent = false;
        }

        /**
         * Save
         * */
        public preSave(): any {
            this.sectionEndpoint = 'Package';

            if (this.isPreviewMassUpdate) {

                // Create object for save Mass update
                this.model = <IPagerModel>{
                    increase: this.massUpdateCriteria.increase,
                    amount: this.massUpdateCriteria.isPercent ? this.amount * 100 : this.amount,
                    isPercent: this.massUpdateCriteria.isPercent,
                    isMembershipOnly: this.filterCriteria.isMembershipOnly,
                    revertLocation: this.revertLocation,
                }
            } else {
                let currentPage = this.model.pages[this.model.currentPage];
                let originalEntity = this.originalEntity;
                let originalCurrentPage = originalEntity.pages[this.model.currentPage];
                let save = {
                    revertLocation: this.revertLocation,
                    packages: []
                };

                // Find changed items
                _.each(currentPage, (element: any, index) => {
                    if (element.packagePrice !== originalCurrentPage[index].packagePrice) {
                        save.packages.push({
                            id: element.packageTypeId,
                            price: element.packagePrice,
                            oldPrice: originalCurrentPage[index].packagePrice,
                            name: element.packageDisplayName,
                        });
                    }
                });

                this.model = <IPagerModel>save;
            }
        }
    }
}
